export const name = 'pdfShareController';
export default function pdfShareController($mdDialog, $log, $timeout, errorDialogOpen, pdfListService, $translate, Utils) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;

  vm.cancel = cancel;
  vm.downloadCSV = downloadCSV;
  vm.copyLink = copyLink;

  vm.isInProgress = true;
  vm.pdfUrlCollection = undefined;

  init();

  function init(){
    let toShare = vm.selectedPdfs.filter(curr => curr.status === 'completed' || curr.status === 'warning');
    $translate.onReady(()=> {
      if(vm.selectedPdfs.length - toShare.length > 0){
        vm.title = $translate.instant('imposer.composer-main.Composer_Share_PDF_Tip');
        vm.cantDownloadMsg = true;
        vm.isInProgress = false;
      }else {
        vm.title = $translate.instant('imposer.composer-main.Composer_File_Links_Created', [toShare.length]);
        let pdfIds = vm.selectedPdfs.map(curr => curr.pdfId);
        pdfListService.getPdfDownloadUrls(pdfIds).then(pdfUrlCollection => {
          vm.pdfUrlCollection = pdfUrlCollection.pdfUrlList;
          vm.isInProgress = false;
        });
      }
    });
  }

  function cancel() {
    let functionName='pdfShareController.cancel';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    $mdDialog.cancel();

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  function downloadCSV() {
    let functionName='pdfShareController.downloadCSV';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    let csvData = vm.pdfUrlCollection.map(curr => {
        return [curr.pdfName, curr.pdfUrl];
    });
    csvData.unshift(['PDF Name', 'PDF URL']);
    exportToCsv("SharedPdfs.csv", csvData);
    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  function copyLink(pdf){
      Utils.copyTextToClipboard(pdf.pdfUrl);
      pdf.copied = true;
      $timeout(function(){
        pdf.copied = false;
      },2000);
  }

  function exportToCsv(filename, rows) {
    var processRow = function (row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) {
          result = '"' + result + '"';
        }
        if (j > 0) {
          finalVal += ',';
        }
        finalVal += result;
      }
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
}
